module.exports = __webpack_public_path__ + "static/media/maria.69c2c1a6.jpeg";